export default "__VITE_ASSET__ee1cdae8__"